// extracted by mini-css-extract-plugin
export default {"button":"CardSelectButton_button__CyzMp","logo":"CardSelectButton_logo__8kHU9","title":"CardSelectButton_title__F396v"};